import { createAppAsyncThunk } from '../../store/extensions';
import { PollDto } from './dtos/PollDto';
import { SubmitPollDto } from './dtos/SubmitPollDto';
import {
  createNewPollCall,
  deletePollCall,
  fetchPollCall,
  fetchPollsCall,
  getNumberOfActiveAndClosedPollsCall,
  reportPollCall,
  submitPollCall,
  updatePollCall,
  moderatorDeletePollCall,
} from './service';

export const fetchPolls = createAppAsyncThunk(
  'poll/getAll',
  (args: {
    xMsContinuationToken?: string;
    numrecs?: number;
    roomId?: string;
  }) => {
    return fetchPollsCall(
      args.xMsContinuationToken,
      args.numrecs,
      undefined,
      args.roomId
    );
  }
);

export const fetchFilteredPolls = createAppAsyncThunk(
  'poll/getAllFiltered',
  (args: {
    xMsContinuationToken?: string;
    numrecs?: number;
    status?: string;
    roomId?: string;
  }) => {
    return fetchPollsCall(
      args.xMsContinuationToken,
      args.numrecs,
      args.status,
      args.roomId
    );
  }
);

export const getNumberOfActiveAndClosedPolls = createAppAsyncThunk(
  'poll/getNumberOfActiveAndClosed',
  (args: { roomId: string }) => {
    return getNumberOfActiveAndClosedPollsCall(args.roomId);
  }
);

export const fetchPoll = createAppAsyncThunk(
  'poll/getById',
  (pollId: string) => {
    return fetchPollCall(pollId);
  }
);

export const submitPoll = createAppAsyncThunk(
  'poll/submit',
  (pollToSubmit: SubmitPollDto) => {
    return submitPollCall(pollToSubmit);
  }
);

export const createNewPoll = createAppAsyncThunk(
  'poll/create',
  async (poll: { poll: PollDto; roomId: string }, { dispatch }) => {
    const responsePoll = await createNewPollCall(poll.poll, poll.roomId);
    dispatch(fetchPolls({ roomId: poll.roomId }));
    dispatch(getNumberOfActiveAndClosedPolls({ roomId: poll.roomId }));
    return responsePoll;
  }
);

export const reportPoll = createAppAsyncThunk(
  'poll/report',
  (pollId: string) => {
    return reportPollCall(pollId);
  }
);

export const updatePoll = createAppAsyncThunk(
  'poll/update',
  async (poll: { poll: PollDto; roomId: string }, { dispatch }) => {
    const response = await updatePollCall(poll.poll);
    dispatch(fetchPolls({ roomId: poll.roomId }));
    return response;
  }
);

export const deletePoll = createAppAsyncThunk(
  'poll/delete',
  async (poll: { pollId: string; roomId: string }, { dispatch }) => {
    const response = await deletePollCall(poll.pollId);
    dispatch(fetchPolls({ roomId: poll.roomId }));
    return response;
  }
);

export const moderatorDeletePoll = createAppAsyncThunk(
  'poll/moderator/delete',
  (poll: { pollId: string; roomId: string }, { dispatch }) => {
    const response = moderatorDeletePollCall(poll.pollId, poll.roomId);
    dispatch(fetchPolls({ roomId: poll.roomId }));
    return response;
  }
);
